import axios from '../config/axiosConfig';

const API_URL = '/cross-framework';

const getWstgForMitre = async (techniqueId) => {
  const response = await axios.get(`${API_URL}/wstg-for-mitre/${techniqueId}`);
  return response.data;
};

const getMitreForWstg = async (testId) => {
  const response = await axios.get(`${API_URL}/mitre-for-wstg/${testId}`);
  return response.data;
};

const getMatrix = async (campaignId) => {
  const response = await axios.get(`${API_URL}/matrix/${campaignId}`);
  return response.data;
};

const getCoverage = async (campaignId) => {
  const response = await axios.get(`${API_URL}/coverage/${campaignId}`);
  return response.data;
};

const crossFrameworkService = {
  getWstgForMitre,
  getMitreForWstg,
  getMatrix,
  getCoverage
};

export default crossFrameworkService;
